const decode = (encoded) => {
  try {
    return atob(encoded);
  } catch {
    return "";
  }
};

// Obfuscation only: this hides the raw literals a bit, but it is not secure in frontend code.
const FALLBACK_CREDENTIALS = {
  username: decode("ZGlucGFyYWNoYTFAZ21haWwuY29t"),
  password: decode("bWFuYWdlcg=="),
  tenantId: 4,
};

export function getConnectUmmahCredentials() {
  return {
    username: process.env.REACT_APP_USERNAME || FALLBACK_CREDENTIALS.username,
    password: process.env.REACT_APP_PASSWORD || FALLBACK_CREDENTIALS.password,
    tenantId: Number(process.env.REACT_APP_TENANT_ID || FALLBACK_CREDENTIALS.tenantId),
  };
}
